import script from "./HoldingEditFormTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./HoldingEditFormTemplate.vue?vue&type=script&setup=true&lang=js"

import "./HoldingEditFormTemplate.vue?vue&type=style&index=0&id=4ff38244&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ff38244"]])

export default __exports__